import React, { useContext } from 'react';

import { ReliabilityOption } from '../../pages/reliability-calculator';
import { ReliabilityCalculatorContext } from './Context';
import { getDefaultSLOBasedOnTier } from './Step4';

const Step1 = () => {
  const {
    state: { step1 },
    dispatch,
  } = useContext(ReliabilityCalculatorContext);

  return (
    <div className="reliabilityCalculator__cell">
      <div className="hero-titleWrapper u-contrast">
        <h1 className="hero-title">How critical is this service?</h1>
      </div>

      <div className="reliabilityCalculator__grid-3">
        <ReliabilityOption
          title="Tier 1"
          active={step1 === 'tier_1'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step1: 'tier_1',
                step4: getDefaultSLOBasedOnTier('tier_1'),
              },
            });
          }}
        >
          <p>
            This service is user-facing, revenue-generating, or is a service
            upon which other Tier 1 services have hard dependencies.
          </p>
        </ReliabilityOption>
        <ReliabilityOption
          title="Tier 2"
          active={step1 === 'tier_2'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step1: 'tier_2',
                step4: getDefaultSLOBasedOnTier('tier_2'),
              },
            });
          }}
        >
          <p>
            Can be user-facing or not, but other services have hard dependencies
            on it or it is required to accurately and consistently persist data.
          </p>
        </ReliabilityOption>
        <ReliabilityOption
          title="Tier 3"
          active={step1 === 'tier_3'}
          onClick={() => {
            dispatch({
              type: 'choice',
              payload: {
                step1: 'tier_3',
                step4: getDefaultSLOBasedOnTier('tier_3'),
              },
            });
          }}
        >
          <p>
            Not user-facing and no other services have hard dependencies on it.
            There is little to no risk of data corruption if the service is
            unavailable.
          </p>
        </ReliabilityOption>
      </div>
    </div>
  );
};

export default Step1;
